module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pAV1W"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_12",
      "id": "CC_12"
    }
  }, [_vm._v(" Elinor’s Eggnog")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "AJJY"
    }
  }, [_c('i', [_vm._v(" A Mayberry holiday tradition. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAdq"
    }
  }, [_c('b', [_vm._v(" 6 eggs ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AV0"
    }
  }, [_c('b', [_vm._v(" 1 cup milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "A7C"
    }
  }, [_c('b', [_vm._v(" ⅔ cup sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AMNg"
    }
  }, [_c('b', [_vm._v(" 1 teaspoon nutmeg ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAgV"
    }
  }, [_c('b', [_vm._v(" ¼ teaspoon salt ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "Aet5"
    }
  }, [_c('b', [_vm._v(" 1 teaspoon vanilla extract ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AL25"
    }
  }, [_c('b', [_vm._v(" 1 cup heavy whipping cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AUxG"
    }
  }, [_c('b', [_vm._v(" Rum or brandy, optional ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAZ3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("S")]), _vm._v("eparate eggs. Put whites in a bowl and refrigerate. In a glass bowl, beat egg yolks; then add milk, sugar, nutmeg, and salt. Mix well and microwave on high power for 3 minutes, stirring well after each minute. Chill mixture for several hours. Beat egg whites until fluffy and then gently stir them into chilled egg-milk mixture. Stir in vanilla. Whip cream until thick; then add to the rest. (When Barney’s not looking, Otis likes to add a little rum or brandy.) Serve very cold. If using a punch bowl, chill bowl in freezer beforehand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pA4_"
    }
  }, [_vm._v("Makes 1 quart.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAeu"
    }
  }, [_c('i', [_vm._v("Cindee and Paul Mulik—Joplin, Missouri")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "Af39"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pA0x"
    }
  }, [_c('i', [_vm._v("It’s beginning to taste a lot like Christmas:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pAfi"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "Afi"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-Afi-0"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "id": "td-Afi-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Afi-0-1"
    }
  }, [_vm._v("Oh, looky at the eggnog!")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Afi-1"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Afi-1-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ELLIE:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Afi-1-1"
    }
  }, [_vm._v("Try some right now.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Afi-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Afi-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Afi-2-1"
    }
  }, [_vm._v("All right. I’ll try a bite of that. Golly, that’s good eggnog!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pA8OJ"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-15-1.jpg",
      "id": "A8OJ",
      "src": "images/img-15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pA-u"
    }
  }, [_c('i', [_vm._v("CHRISTMAS SPIRITS—Even Scrooge couldn't resist Ellie's Eggnog during Christmastime in Mayberry.")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "Abax"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pAit"
    }
  }, [_c('i', [_vm._v("So how does Aunt Bee’s lemonade rate with somebody who’s been watching Andy replace shingles on a hot roof all day?:")])]), _vm._v(" "), _c('table', [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("MR. WHEELER:")])]), _vm._v(" "), _c('td', [_vm._v("Mmm, mmm, mmm! Just hits the spot!")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3f916d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter12.vue
// module id = 99
// module chunks = 0